'use strict';

(function (window, document, undefined) {
  var recaptchaLoaded = false
  var submitter = null
  var defaults = {
    // Selectors
    alertSelector: '.js-alert',
    alertList: '#alert-list',
    alertTemplate: '.js-alert-template',
    fieldSelector: '.js-field',
    fieldControlSelector: '.js-field-control',
    fieldFeedbackSelector: '.js-field-feedback',
    // AJAX
    ajax: false,
    ajaxSuccessCallback: null,
    // ajaxSuccessCallback(form) {},
    ajaxErrorCallback: null,
    // ajaxErrorCallback(form) {},
    // Animation Functions
    animationShowFeedback: null,
    // animationShowFeedback(feedback) {},
    animationHideFeedback: null,
    // animationHideFeedback(feedback) {},
    animationShowAlert: null,
    // animationShowAlert(alert) {},
    animationHideAlert: null,
    // animationHideAlert(alert, done) {},
    // reCAPTCHA Settings
    recaptchaSiteKey: undefined,
    // Pass in object of custom validations
    localisation: {
      alerts: {
        recaptchaExpired: 'reCAPTCHA has expired, please try again',
        recaptchaProblem: 'There is a problem with reCAPTCHA, please try again',
        submissionProblem:
          'There was a problem submitting the form, please try again',
        submissionSuccess: 'The form was submitted successfully',
      },
    }
  }

  /**
   * Helper functions
   * @private
   */

  function _typeof (obj) {
    '@babel/helpers - typeof'
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
      _typeof = function _typeof (obj) {
        return typeof obj
      }
    } else {
      _typeof = function _typeof (obj) {
        return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
          ? 'symbol'
          : typeof obj
      }
    }
  }

  function deepExtend (out) {
    out = out || {}

    for (
      var i = 0;
      i < (arguments.length <= 1 ? 0 : arguments.length - 1);
      i++
    ) {
      var obj =
        i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]

      if (!obj) {
        continue
      }

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (_typeof(obj[key]) === 'object') {
            out[key] = deepExtend(out[key], obj[key])
          } else {
            out[key] = obj[key]
          }
        }
      }
    }

    return out
  }

  /**
   * Asynchronously load scripts in with a callback
   * @param {String} source URL of script file
   * @param {Function} loadCallback On load callback
   * @param {Function} errorCallback On error callback
   */
  function getScript (source, loadCallback, errorCallback) {
    var script = document.createElement('script')
    var prior = document.getElementsByTagName('script')[0]
    script.async = 1

    script.onload = script.onreadystatechange = function (_, isAbort) {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = script.onreadystatechange = null
        script = undefined

        if (!isAbort && loadCallback) {
          loadCallback()
        }
      }
    }

    if (errorCallback) {
      script.onerror = function () {
        errorCallback()
      }
    }

    script.src = source
    prior.parentNode.insertBefore(script, prior)
  }

  /**
   * Validate Constructor
   * @param {Object} form The form element
   * @param {Object} options User options
   */

  function Validate (form, options) {
    // Merge defaults and user options
    this.defaults = defaults
    this.settings = deepExtend({}, this.defaults, options) // Elements

    this.form = form
    this.controls = form.querySelectorAll(this.settings.fieldControlSelector)
    this.recaptchaRendered = false
    this.submitButton = null

    if (!document.querySelector(this.settings.alertList)) {
      console.warn(
        'Validate.js requires an \'alert list\' element to correctly add reCAPTCHA alerts, please check your configuration.'
      )
    }

    if (!document.querySelector(this.settings.alertTemplate)) {
      console.warn(
        'Validate.js requires an \'alert template\' element to correctly add reCAPTCHA alerts, please check your configuration.'
      )
    }

    if (
      this.settings.recaptchaSiteKey &&
      !this.form.querySelector('.g-recaptcha')
    ) {
      console.warn(
        'This instance of Validate is configured to use reCAPTCHA, but no `.g-recaptcha` element was found. Please check your configuration.'
      )
    }

    this.init()
  }

  /**
   * Validate Prototype
   * @public
   */
  Validate.prototype = {

    init: function init () {
      this.form.setAttribute('novalidate', 'novalidate') // Setup aria attributes on inputs - TODO: Support DOM changes and
      // automatically update

      for (var i = 0; i < this.controls.length; i++) {
        if (
          this.controls[i].attributes &&
          this.controls[i].attributes['required']
        ) {
          this.controls[i].setAttribute('aria-required', true)
        }

        if (this.controls[i].closest('.js-field.is-invalid')) {
          this.controls[i].setAttribute('aria-invalid', true)
        } else {
          this.controls[i].setAttribute('aria-invalid', false)
        }
      }

      this.addEventListeners() // Focus first invalid on initialisation for any existing errors

      this.focusFirstInvalid()
    },

    loadRecaptcha: function loadRecaptcha () {
      var _this = this

      if (this.settings.recaptchaSiteKey) {
        if (!recaptchaLoaded) {
          window.recaptchaCallback = this.recaptchaCallback
          window.currentValidateInstance = this
          getScript(
            'https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit',
            null,
            function () {
              _this.addAlert(
                _this.settings.localisation.alerts.recaptchaProblem,
                'invalid'
              )
            }
          )
        } else {
          this.recaptchaCallback(this)
        }
      }
    },
    addEventListeners: function addEventListeners () {
      var _this2 = this

      this.form.addEventListener('submit', function (e) {
        e.preventDefault() // Update controls NodeList in case form DOM has changed

        if (e.submitter) {
          submitter = e.submitter
        }

        if (_this2.settings.recaptchaSiteKey && !_this2.recaptchaRendered) {
          var recaptchaLoadHandler = function recaptchaLoadHandler () {
            _this2.form.dispatchEvent(
              new Event('submit', {
                cancelable: true,
              })
            )

            _this2.form.removeEventListener(
              'recaptcha_loaded',
              recaptchaLoadHandler
            )
          }

          _this2.form.addEventListener(
            'recaptcha_loaded',
            recaptchaLoadHandler
          )

          _this2.loadRecaptcha()

          return false
        }

        var recaptchaEl = _this2.form.querySelector('.g-recaptcha')

        if (_this2.settings.recaptchaSiteKey && recaptchaEl) {
          if (typeof grecaptcha === 'undefined') {
            // If reCAPTCHA isn't present, it's either blocked by the user or there's
            // an issue with the CDN. Handle custom logic here, i.e. show an alert
            // indicating the user may need to try again
            _this2.addAlert(
              _this2.settings.localisation.alerts.recaptchaProblem,
              'invalid'
            )

            return false
          }

          grecaptcha.execute(
            parseInt(recaptchaEl.getAttribute('data-recaptcha-id'))
          )
        } else {
          // Doesn't use reCAPTCHA, bypass reCAPTCHA check manually
          _this2.form.dispatchEvent(new CustomEvent('recaptcha_passed'))
        }

      })
      this.form.addEventListener('recaptcha_passed', function () {
        // If the submit button has a name and a value (e.g. if there are
        // multiple submit buttons), create a hidden input and apply its value
        var submitterInput = null

        if (submitter && submitter.name && submitter.value) {
          submitterInput = document.createElement('input')
          submitterInput.type = 'hidden'
          submitterInput.name = submitter.name
          submitterInput.value = submitter.value

          _this2.form.appendChild(submitterInput)
        }

        if (_this2.settings.ajax === true) {
          var request = new XMLHttpRequest()
          var action

          if (submitter && submitter.formAction) {
            action = submitter.formAction
          } else {
            action =
              _this2.form.action ||
              _this2.form.getAttribute('action') ||
              location.href
          }

          request.open("POST", action, true);
          request.setRequestHeader("X-Requested-With", "XMLHttpRequest");

          if (submitter && submitter.classList) {
            submitter.classList.add('is-loading')
          }

          request.onload = function () {
            var responseJSON = JSON.parse(request.response)

            if (submitter && submitter.classList) {
              submitter.classList.remove('is-loading')
            }

            var recaptchaEl = _this2.form.querySelector('.g-recaptcha')

            if (request.status >= 200 && request.status < 400) {
              // Success handler
              _this2.addAlert(
                responseJSON.message ||
                _this2.settings.localisation.alerts.submissionSuccess,
                'valid'
              ) // Reset form, clear any submitter stuff

              _this2.form.reset()

              var fields = _this2.form.querySelectorAll(_this2.settings.fieldSelector)

              for (var i = 0; i < fields.length; i++) {
                fields[i].classList.remove('is-invalid')
                fields[i].querySelector(_this2.settings.fieldFeedbackSelector).innerHTML = ''
              }

              submitter = null

              if (submitterInput) {
                submitterInput.parentNode.removeChild(submitterInput)
              }

              if (_this2.settings.recaptchaSiteKey && recaptchaEl) {
                grecaptcha.reset(
                  parseInt(recaptchaEl.getAttribute('data-recaptcha-id'))
                )
              }

              if (typeof _this2.settings.ajaxSuccessCallback === 'function') {
                _this2.settings.ajaxSuccessCallback.call(_this2, _this2.form)
              }

              _this2.dismissAlerts()

            } else {

              if (_this2.settings.recaptchaSiteKey && recaptchaEl) {
                grecaptcha.reset(
                  parseInt(recaptchaEl.getAttribute('data-recaptcha-id'))
                )
              }

              _this2.addAlert(
                responseJSON.message ||
                _this2.settings.localisation.alerts.submissionProblem,
                'invalid'
              )

              var errors = responseJSON.errors

              for (var key in errors) {
                var input = _this2.form.querySelector(
                  '[name="'.concat(key, '"]')
                )

                if (input) {
                  var field = input.closest(_this2.settings.fieldSelector)

                  if (field) {
                    _this2.setInvalidState(field, errors[key][0])
                  }
                }
              }

              _this2.focusFirstInvalid() // Clear any submitter stuff

              submitter = null

              if (submitterInput) {
                submitterInput.parentNode.removeChild(submitterInput)
              }

              if (typeof _this2.settings.ajaxErrorCallback === 'function') {
                _this2.settings.ajaxErrorCallback.call(_this2, _this2.form)
              }

              _this2.dismissAlerts()
            }
          }

          request.onerror = function () {
            _this2.addAlert(
              _this2.settings.localisation.alerts.submissionProblem,
              'invalid'
            )
          }

          let formData = new FormData(_this2.form);

          // Remove file fields with empty content from request to fix the backend required validation rule
          const formFiles = _this2.form.querySelectorAll('input[type="file"]');
          if (formFiles.length > 0) {
            formFiles.forEach(formFile => {
              if (formFile.value === '') {
                formData.delete(formFile.name);
              }
            });
          }

          request.send(formData);

        } else {
          // If the submit button has a formaction="" attribute, manually update
          // the form's action here
          if (submitter && submitter.formAction) {
            _this2.form.action = submitter.formAction
          } // Unset submitter to prevent any weirdness if the form hangs and
          // a separate form is clicked, for example

          submitter = null

          _this2.form.submit()
        }
      })
      this.form.addEventListener('recaptcha_error', function () {
        _this2.addAlert(
          _this2.settings.localisation.alerts.recaptchaProblem,
          'invalid'
        )
      })
      this.form.addEventListener('recaptcha_expired', function () {
        _this2.addAlert(
          _this2.settings.localisation.alerts.recaptchaExpired,
          'invalid'
        )
      })
      var alerts = document.querySelectorAll(this.settings.alertSelector)

      var _loop = function _loop (i) {
        alerts[i]
          .querySelector('.js-alert-close')
          .addEventListener('click', function () {
            _this2.removeAlert(alerts[i])
          })
      }

      for (var i = 0; i < alerts.length; i++) {
        _loop(i)
      }
    },
    focusFirstInvalid: function focusFirstInvalid () {
      var invalidFields = this.form.querySelectorAll(
        ''.concat(this.settings.fieldSelector, '.is-invalid')
      )

      if (invalidFields.length) {
        invalidFields[0].querySelector('input, select, textarea').focus()
      }
    },

    /**
     * @param {Object} validateInstance
     */
    recaptchaCallback: function recaptchaCallback (validateInstance) {
      /**
       * This callback needs to be first called from the global scope, so
       * does not have access to the current instance of Validate, so a
       * global variable is set or passed in as argument
       */
      var base

      if (typeof validateInstance === 'undefined') {
        base = window.currentValidateInstance
      } else {
        base = validateInstance
      }

      recaptchaLoaded = true
      var recaptcha = base.form.querySelector('.g-recaptcha')

      if (typeof grecaptcha !== 'undefined') {
        var widgetId = grecaptcha.render(recaptcha, {
          sitekey: base.settings.recaptchaSiteKey,
          size: 'invisible',
          callback: function callback (token) {
            base.form.dispatchEvent(new CustomEvent('recaptcha_passed'))
          },
          'error-callback': function errorCallback () {
            base.form.dispatchEvent(new CustomEvent('recaptcha_error'))
          },
          'expired-callback': function expiredCallback () {
            base.form.dispatchEvent(new CustomEvent('recaptcha_expired'))
          },
        })
        recaptcha.setAttribute('data-recaptcha-id', widgetId)
        base.recaptchaRendered = true
      } else {
        base.addAlert(
          this.settings.localisation.alerts.recaptchaProblem,
          'invalid'
        )
      }

      base.form.dispatchEvent(new CustomEvent('recaptcha_loaded')) // Remove global pollution

      window.recaptchaCallback = null
      window.currentValidateInstance = null
    },

    /**
     * @param {String} message
     * @param {String} level
     */
    addAlert: function addAlert (message, level) {
      var _this3 = this

      var alertList = document.querySelector(this.settings.alertList)
      var alert = document
        .querySelector(this.settings.alertTemplate)
        .cloneNode(true)
      var alertClose = alert.querySelector('.js-alert-close')
      alertList.classList.remove('is-all-dismissed')
      alertList.appendChild(alert)
      alert.classList.add('alert-'.concat(level))
      alert.style.display = 'block'

      if (typeof this.settings.animationShowAlert === 'function') {
        this.settings.animationShowAlert.call(this, alert)
      }

      alert.querySelector('.js-alert-message').innerHTML = message

      if (alertClose) {
        alertClose.addEventListener('click', function () {
          _this3.removeAlert(alert)
        })
      }
    },

    /**
     * @param {Object} alert
     */
    removeAlert: function removeAlert (alert) {

      let alertList = document.querySelector('.js-flash-messages')
      alert.classList.add('hidden')

      setTimeout(() => {
        alert.remove()
        let currentAlerts = alertList.querySelectorAll('.js-flash-message.alert-valid, .js-flash-message.alert-invalid')
        if (currentAlerts.length === 0) {
          alertList.classList.add('is-all-dismissed')
        }
      }, 600)

    },

    dismissAlerts: function dismissAlerts() {
      var _this4 = this

      let currentAlerts = document.querySelectorAll('.js-flash-message.alert-valid, .js-flash-message.alert-invalid')

      for (let i = 0; i < currentAlerts.length; i++) {
        setTimeout(() => {
          _this4.removeAlert(currentAlerts[i])
        }, 5000)
      }
    },

    /**
     * @param {Object} field
     */
    setValidState: function setValidState (field) {
      var fieldFeedback = field.querySelector(
        this.settings.fieldFeedbackSelector
      )
      field.classList.add('is-valid')

      if (typeof this.settings.animationHideFeedback === 'function') {
        this.settings.animationHideFeedback.call(this, fieldFeedback)
      }
    },

    /**
     * @param {Object} field
     * @param {String} message
     */
    setInvalidState: function setInvalidState (field, message) {
      var fieldFeedback = field.querySelector(
        this.settings.fieldFeedbackSelector
      )
      field.classList.add('is-invalid')

      if (message) {
        fieldFeedback.innerHTML = message

        if (typeof this.settings.animationShowFeedback === 'function') {
          this.settings.animationShowFeedback.call(this, fieldFeedback)
        }
      }
    },
  }
  window.Validate = Validate
})(window, document)
